import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addFirstCardDescription, popupChange, popUpMenuChange, selectedCardsGroupsChange, toggleSwitch } from '../../actions/index';

import ViewButton from './viewButton';
import ReleaseButton from './releaseButton';
import SignButton from './signButton';
import DeleteButton from './deleteButton';
import AddProgressButton from './addProgressButton';
import UpdateButton from './updateButton';
import StandByButton from './standByButton';
import ReopenButton from './reopenButton';
import EnlargeTunnelButton from './enlargeTunnelButton';
import AddCostsButton from './adminButtons/addCostsButton';
import ChangeCategoryButton from './adminButtons/changeCategoryButton';
import ChangeLevelButton from './adminButtons/changeLevelButton';
import MassClosingButton from './adminButtons/massClosingButton';
import ExportCertificatesButton from './exportCertificatesButton';
import ExportObservationsButton from './exportObservationsButton';
import ExportRegistersButton from './exportRegistersButton';
import ExportCardsButton from './exportCardsButton';
import AssignUsersButton from './assignUsersButton';
import AddPaymentButton from './addPaymentButton';
import UnfulfilledButton from './unfulfilledButton';
import GanttChartDatesButton from './ganttChartDatesButton';
import ExportObservationsPdfButton from './exportObservationsPdfButton';
import TunnelSubdivisionsButton from './adminButtons/tunnelSubdivisionsButton';
import CardsGroupsList from '../popUpCardsGroups/cardsGroupsList';
import MaterialsInfo from './materialsInfo';
import CloseIcon from '@material-ui/icons/Close';

import { checkFailuresSelected, checkTunnelConditions, groupCardsGroupIds } from '../../functions/cardsGroupsFeatures';
import { getCustomCardButtons } from '../../functions/popUpMenu/buttonsToRender';
import { _ } from '../../functions/translator';
import { CardsGroupStatus, ToggleActions } from '../../constants/constants';
import { postData } from '../../functions/postData';
import AsignCycleButton from './cycles/asignCycleButton';
import MergeButton from './cycles/mergeButton';
import SeparateButton from './cycles/separateButton';
import DropdownButton from './dropdownButton';
import ExportWeightingsButton from './exportWeightingsButton';

class PopUpMenu extends React.Component {

  constructor(props) {
      super(props)
      this.state = {
          animationTime: 900,
          submenuOpen: null,
          isSmallScreen: window.innerWidth < 1315
      }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateScreenSize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateScreenSize);
  }

  updateScreenSize = () => {
    this.setState({ isSmallScreen: window.innerWidth < 1315 });
  };

  handleClosePopup = () => {
    if (this.props.popup !== 'none') {
      this.props.popupChange('none');
    } else if (this.props.popUpMenu.expanded) {
      this.props.popUpMenuChange({ show: true, expanded: false });
    } else {
      this.props.popUpMenuChange({ show: false, close: false, closeList: false, expanded: false, opacity: 1, cyclesButton: false, changeMenuButton: false });
      this.props.selectedCardsGroupsChange('none');
    }
  };

  handleAnimationClosePopup = () => {
    this.background.classList.remove('circle-background-animation');
    this.props.popUpMenuChange({ close: true, closeList: true, opacity: 1 });
    setTimeout(() => this.handleClosePopup(), this.state.animationTime);
  };

  loadFailureDescriptions = async (cardsGroupIds) => {
    const loadIsNeeded = cardsGroupIds.some(id => !this.props.projectData.cards_groups[id]?.attributes?.hasOwnProperty('first_card_description'));
    if (!loadIsNeeded) return;

    try {
      const url = '/web-api/get-cards-groups-first-card-description';
      const urlContent = { project_id: window.project_id, cards_group_ids: cardsGroupIds };
      this.props.toggleSwitch(ToggleActions.CARDS_LOADING);
      const result = await postData(url, urlContent);
      if (result.status === 'success') {
        this.props.addFirstCardDescription(result.descriptions);
      }
    } catch (err) {
      console.log('Error loading failure descriptions', err);
    } finally {
      this.props.toggleSwitch(ToggleActions.CARDS_LOADING);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.popUpMenu.show !== this.props.popUpMenu.show) {
      this.setState({ submenuOpen: null });
    }
    if (this.props.popUpMenu.close) return;
    if (this.background && !this.background.classList.contains('circle-background-animation')) {
      this.background.classList.add('circle-background-animation');
    }
  }

  handleSubmenuHover = ( menuId, show ) => {
    if (show) {
      this.setState({ submenuOpen: menuId });
    } else {
      // Don't close the submenu if a modal is open in the DOM
      if (document.querySelector('.modal.show')) return;
      this.setState({ submenuOpen: null });
    }
  };

  handleSubmenuClick = (menuId) => {
    this.setState(prev => ({
      submenuOpen: prev.submenuOpen === menuId ? null : menuId
    }));
  };

  getButtonsToRender = (cardsGroupIds, groupedCardsGroupIds) => {
    const buttons = [];
    const closable = groupedCardsGroupIds[CardsGroupStatus.OPEN].concat(
      groupedCardsGroupIds[CardsGroupStatus.IN_PROGRESS],
      groupedCardsGroupIds[CardsGroupStatus.WITH_NO_CONFORMITIES],
      groupedCardsGroupIds[CardsGroupStatus.CLOSED]
    );
    const passTunnel = checkTunnelConditions(cardsGroupIds, this.props.projectData);

    buttons.push(<ViewButton />);

    if (this.props.userRole.admin) {
      buttons.push(
        <div className="submenu-button-wrapper"
            onMouseEnter={!this.state.isSmallScreen ? () => this.handleSubmenuHover('change', true) : undefined}
            onMouseLeave={!this.state.isSmallScreen ? () => this.handleSubmenuHover('change', false) : undefined}
            onClick={this.state.isSmallScreen ? () => this.handleSubmenuClick('change') : undefined}>
          <div>
            <DropdownButton title={'Editar'}  active={this.state.submenuOpen === 'change'} smallScreen={this.state.isSmallScreen}/>
          </div>
          {this.state.submenuOpen === 'change' && (
            <div className="submenu">
                <ChangeCategoryButton cardsGroupIds={cardsGroupIds}/>
                <ChangeLevelButton cardsGroupIds={cardsGroupIds}/>
            </div>
          )}
        </div>
      );
      const hasClosableForMassClosing = 
        groupedCardsGroupIds[CardsGroupStatus.OPEN].length > 0 ||
        groupedCardsGroupIds[CardsGroupStatus.IN_PROGRESS].length > 0 ||
        groupedCardsGroupIds[CardsGroupStatus.WITH_NO_CONFORMITIES].length > 0 ||
        groupedCardsGroupIds[CardsGroupStatus.UNFULFILLED].length > 0;
      if (hasClosableForMassClosing) {
        buttons.push(<MassClosingButton />);
      }
    }
    if (this.props.userRole.add_progress_update) {
      buttons.push(<AddCostsButton />);
    }
    if (groupedCardsGroupIds[CardsGroupStatus.STAND_BY].length && this.props.userRole.add_card) {
      buttons.push(<ReleaseButton standByCardsGroups={groupedCardsGroupIds[CardsGroupStatus.STAND_BY]} />);
    }
    if (this.props.userRole.update_card && (groupedCardsGroupIds.separable.length > 0 || groupedCardsGroupIds.mergeable.cardsGroupIds.length > 1)) {
      buttons.push(
        <div className="submenu-button-wrapper"
            onMouseEnter={!this.state.isSmallScreen ? () => this.handleSubmenuHover('cycles', true) : undefined}
            onMouseLeave={!this.state.isSmallScreen ? () => this.handleSubmenuHover('cycles', false) : undefined}
            onClick={this.state.isSmallScreen ? () => this.handleSubmenuClick('cycles') : undefined}>
          <div>
            <DropdownButton title={'Agrupar'} active={this.state.submenuOpen === 'cycles'} smallScreen={this.state.isSmallScreen} />
          </div>
          {this.state.submenuOpen === 'cycles' && (
            <div className="submenu">
                <AsignCycleButton 
                mergeableCardsGroups={groupedCardsGroupIds.mergeable} 
                separableCardsGroups={groupedCardsGroupIds.separable}
              />
                <MergeButton 
                mergeableCardsGroups={groupedCardsGroupIds.mergeable}
              />
                <SeparateButton 
                separableCardsGroups={groupedCardsGroupIds.separable}
              />
            </div>
          )}
        </div>
      );
    }
    if (this.props.userRole.batch_update_card && this.props.userRole.update_card && groupedCardsGroupIds.equalProtocols && closable.length > 0) {
      buttons.push(<UpdateButton closableCardsGroups={closable} />);
    }
    if (this.props.userRole.add_progress_update) {
      buttons.push(<AddProgressButton cardsGroupIds={cardsGroupIds} />);
    }
    if (groupedCardsGroupIds[CardsGroupStatus.OPEN].length && this.props.userRole.add_card) {
      buttons.push(<StandByButton cardsGroupIds={groupedCardsGroupIds[CardsGroupStatus.OPEN]} />);
    }
    if (closable.length && this.props.userRole.batch_close && this.props.userRole.sign_revision) {
      buttons.push(<SignButton closableCardsGroups={closable} />);
    }
    if (this.props.userRole.add_card && groupedCardsGroupIds.closedSelectedOnly) {
      buttons.push(<ReopenButton closedCardsGroupIds={groupedCardsGroupIds[CardsGroupStatus.CLOSED]} />);
    }
    if (this.props.userRole.add_card && this.props.userRole.lineal && passTunnel) {
      buttons.push(<EnlargeTunnelButton cardsGroupIds={cardsGroupIds} />);
    }
    if (this.props.userRole.admin && cardsGroupIds.length === 1) {
      buttons.push(<TunnelSubdivisionsButton />);
    }
    if (this.props.userRole.delete_card) {
      buttons.push(<DeleteButton cardsGroupIds={cardsGroupIds} />);
    }

    const { selectedCardsGroups, projectData } = this.props;
    let hasAppartment = false;
    if (
      selectedCardsGroups &&
      Array.isArray(selectedCardsGroups) &&
      selectedCardsGroups.length > 0
    ) {
      hasAppartment = selectedCardsGroups.some(
        id =>
          projectData &&
          projectData.cards_groups &&
          projectData.cards_groups[id] &&
          projectData.cards_groups[id].attributes &&
          projectData.cards_groups[id].attributes.hasOwnProperty('appartment_id') &&
          projectData.cards_groups[id].attributes.appartment_id
      );
    }

    const hasNonStandByCardsGroup = groupedCardsGroupIds[CardsGroupStatus.STAND_BY].length < selectedCardsGroups.length;

    buttons.push(
      <div className="submenu-button-wrapper"
          onMouseEnter={!this.state.isSmallScreen ? () => this.handleSubmenuHover('export', true) : undefined}
          onMouseLeave={!this.state.isSmallScreen ? () => this.handleSubmenuHover('export', false) : undefined}
          onClick={this.state.isSmallScreen ? () => this.handleSubmenuClick('export') : undefined}>
        <div>
          <DropdownButton title={'Exportar'} active={this.state.submenuOpen === 'export'} smallScreen={this.state.isSmallScreen}/>
        </div>
        {this.state.submenuOpen === 'export' && (
          <div className="submenu">
              <ExportObservationsButton/>
              <ExportRegistersButton/>
              <ExportCertificatesButton/>
              <ExportObservationsPdfButton/>
              <ExportCardsButton/>
              {hasAppartment && hasNonStandByCardsGroup && <ExportWeightingsButton/>}
          </div>
        )}
      </div>
    );

    if (this.props.userRole.edit_team) {
      buttons.push(<AssignUsersButton />);
    }

    if (this.props.userRole.sensitive_data) {
      buttons.push(<AddPaymentButton cardsGroupIds={cardsGroupIds} />);
    }

    buttons.push(
      <div className="submenu-button-wrapper"
          onMouseEnter={!this.state.isSmallScreen ? () => this.handleSubmenuHover('add', true) : undefined}
          onMouseLeave={!this.state.isSmallScreen ? () => this.handleSubmenuHover('add', false) : undefined}
          onClick={this.state.isSmallScreen ? () => this.handleSubmenuClick('add') : undefined}>
        <div>
          <DropdownButton title={'Agregar'} active={this.state.submenuOpen === 'add'} smallScreen={this.state.isSmallScreen}/>
        </div>
        {this.state.submenuOpen === 'add' && (
          <div className="submenu">
              {getCustomCardButtons(this.props.projectData).map(b => b)}
          </div>
        )}
      </div>
    );

    if (this.props.userRole.mark_as_unfulfilled) {
      buttons.push(<UnfulfilledButton cardsGroupIds={cardsGroupIds} />);
    }
    if (this.props.userRole.add_card) {
      buttons.push(<GanttChartDatesButton cardsGroupIds={cardsGroupIds} />);
    }

    
    return buttons;
  };

  render() {
    if (!this.props.popUpMenu.show || this.props.selectedCardsGroups === 'none' || this.props.selectedCardsGroups.length === 0) return null;

    const failureIds = checkFailuresSelected(this.props.selectedCardsGroups, this.props.projectData);
    if (failureIds.length > 0) this.loadFailureDescriptions(failureIds);

    const grouped = groupCardsGroupIds(this.props, this.props.selectedCardsGroups);
    const title = this.props.selectedCardsGroups.length > 1 ? _('registros seleccionados') : _('registro seleccionado');
    const buttons = this.getButtonsToRender(this.props.selectedCardsGroups, grouped);
    const isAnySubmenuOpen = this.state.submenuOpen !== null
    const buttonsContainerClass = `popup-menu-buttons-container ${isAnySubmenuOpen ? 'extend' : ''}`;

    return (
      <div className='popup-menu-layout'>
        <div className="circle-background" ref={ref => this.background = ref} onClick={this.handleClosePopup} />

        {!this.props.popUpMenu.expanded && (
          <h3 className='popup-menu-title'>{this.props.selectedCardsGroups.length + ' ' + title}</h3>
        )}

        <div className='popup-menu-container mt-3'>
          <CardsGroupsList cardsGroupsByCategory={grouped.byCategory} />
          {!this.props.popUpMenu.expanded && (
            <div className={buttonsContainerClass}>
              {buttons.map((btn, i) => <div key={i}>{btn}</div>)}
            </div>
          )}
          {!isAnySubmenuOpen &&
            <MaterialsInfo 
            popUpMenu={this.props.popUpMenu} 
            selectedCardsGroupIds={this.props.selectedCardsGroups} 
            projectData={this.props.projectData} />
          }
        </div>

        <CloseIcon className='popup-menu-close float-right cursor-pointer' onClick={this.handleClosePopup} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  projectData: state.projectData,
  popup: state.popup,
  popUpMenu: state.popUpMenu,
  selectedCardsGroups: state.selectedCardsGroups,
  userRole: state.userRole,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  addFirstCardDescription,
  popupChange,
  popUpMenuChange,
  selectedCardsGroupsChange,
  toggleSwitch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PopUpMenu);